var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "agent-roles" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "page-header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "page-title" }, [_vm._v("Roles")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "breadcrumb" }, [
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "/index" } }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: "/client/agents/list" } },
                          [_vm._v("Agent")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v("Roles")
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card mb-0" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-4 col-md-4 col-lg-4 col-xl-4" },
                        [
                          _c("ul", { staticClass: "personal-info" }, [
                            _c("li", [
                              _c("span", { staticClass: "title" }, [
                                _vm._v("Name:")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text" }, [
                                _vm._v(_vm._s(_vm.agent.name))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("span", { staticClass: "title" }, [
                                _vm._v("Email:")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text" }, [
                                _vm._v(_vm._s(_vm.agent.email))
                              ])
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-md-8 col-lg-8 col-xl-8" },
                        [
                          _c("h6", { staticClass: "card-title m-b-20" }, [
                            _vm._v("Roles Access")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "m-b-30" },
                            [
                              _vm.loading
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "w-100" },
                                      [_c("Skeleton", { attrs: { count: 1 } })],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.rows.length
                                ? _vm._l(_vm.rows, function(row, index) {
                                    return _c(
                                      "ul",
                                      {
                                        key: index,
                                        staticClass:
                                          "list-group notification-list"
                                      },
                                      [
                                        _c(
                                          "li",
                                          { staticClass: "list-group-item" },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(row.name) +
                                                "\n                            "
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "status-toggle" },
                                              [
                                                _c("input", {
                                                  ref: "rel-" + row.id,
                                                  refInFor: true,
                                                  staticClass: "check",
                                                  attrs: {
                                                    type: "checkbox",
                                                    id: row.id
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.handleRolesOne(
                                                        row.id
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass: "checktoggle",
                                                    attrs: { for: row.id }
                                                  },
                                                  [_vm._v("checkbox")]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                : _vm.rows.length < 1 && !_vm.loading
                                ? [
                                    _c("div", { staticClass: "w-100" }, [
                                      _vm._v(
                                        "\n                          -empty-\n                        "
                                      )
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0d6898e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0d6898e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/agents/roles.vue
// module id = null
// module chunks = 